import cx from 'classnames';
import React, { useState, useEffect, useContext } from 'react';
import {
  Col,
  Row,
  Button,
  Modal,
  Form,
  OverlayTrigger,
  Tooltip,
  Image,
  Spinner,
} from 'react-bootstrap';
import ResponsiveImage from '../Image';
import { apiUpdateUserDetails, apiGetUserDetails, apiChangePassword } from '../../helpers/api';
import makeAnimated from 'react-select/animated';
import { RiEyeLine, RiEyeOffLine } from 'react-icons/ri';
import { icons } from '../../assets';
import { Input } from '../../components/common/input';
import { navigate } from '../../helpers/projectHelper';
import { FORGET_ROUTE_SETTINGS } from '../../constants/routePathConstants';
import { UserInfo, ViewEditItem, OrgSection, Loader } from '..';
import _ from 'lodash';
import {
  checkFileSize,
  loadImage,
  objectToFormData,
  passwordIsValid,
  pwdMatchCheck,
  removeUndefinedText,
  setLocalStorage,
} from '../../helpers/jsHelper';
import { BigButton } from '../';
import NormalButton from '../../components/Button/Button';
import { CameraIcon2 } from '../../components/icons/CameraIcon2';
import FileInput from '../../components/FileInput/FileInput';
import { AvatarRow } from '../AvatarRow';
import { InfoIcon } from '../../components/icons/InfoIcon';
import { useUserContext } from '../../contexts/UserContext';
import { CloseIcon } from '../../components/icons/CloseIcon';
import { MAX_DESIGNATION_LENGTH, MAX_FIRST_NAME_LENGTH, MAX_LAST_NAME_LENGTH } from '../../constants/validationConstants';
import '../../assets/scss/_forms.scss';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { Link } from 'react-router-dom';
import {
  CURRENT_USER,
  MAX_PASSWORD_LENGTH,
  MIN_PASSWORD_LENGTH,
  VALID_PASSWORD_MESSAGE,
} from '../../constants/projectConstants';
import { errorToast } from "../../helpers/toastHelper";
//import { captureException } from '@sentry/react';

const { ChangeProfileIcon, EyeIcon, ProfileIcon, ExclamationIcon, CloseIconSmall } = icons;

export default function MyDetails(props) {
  const userCtx = useUserContext();
  const animatedComponents = makeAnimated();
  const [userDetails, setUserDetails] = useState(null);
  const [savePassword, setSavePassword] = useState(false);
  const [data, setData] = useState();
  const [profileImg, setProfileImg] = useState();
  const [passwordShown1, setPasswordShown1] = useState(false);
  const [passwordShown2, setPasswordShown2] = useState(false);
  const [passwordShown3, setPasswordShown3] = useState(false);
  const [show, setShow] = useState(false);
  const [selectedImage, setSelectedImage] = useState('images/profilepic.svg');
  const [countryMessage, setCountryMessage] = useState('');
  const [stateMessage, setStateMessage] = useState('');
  const [cityMessage, setCityMessage] = useState('');
  const [contactNumberMessage, setContactNumberMessage] = useState('');
  const [professionMessage, setProfessionMessage] = useState('');
  const [industryMessage, setIndustryMessage] = useState('');
  const [platformMessage, setPlatformMessage] = useState('');
  const [userData, setUserData] = useState(userDetails);
  const [saving, setSaving] = useState(false);
  const [editingName, setEditingName] = useState(false);
  const [editingDesignation, setEditingDesignation] = useState(false);
  const [firstNameError, setFirstNameError] = useState('');
  const [lastNameError, setLastNameError] = useState('');
  const [maxLimit, setMaxLimit] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getUserDetails();
  }, [userCtx.currentUser.organization]);

  useEffect(() => {
    if (userDetails?.profile_image) {
      setProfileImg(userDetails?.profile_image);
    }
  }, [userDetails]);

  let formData = { ...data };

  const handleShow = () => setShow(true);

  function getUserDetails(callback) {
    setLoading(true);
    apiGetUserDetails()
      .then((response) => {
        if (response) {
          setUserDetails(response);
          userCtx?.updateUserData();
        }
      })
      .finally(() => {
        callback?.();
        setLoading(false);
      });
  }

  function changeUserDetails(data) {
    if (data) {
      let formData = new FormData();

      let userData = Object.entries(data);

      userData.forEach((item) => {
        let key = item[0];
        let value = item[1];

        if (key === 'country') {
          value = value?.label;
        } else if (key === 'state') {
          value = value?.label;
        } else if (key === 'profession') {
          value = value?.value;
        } else if (key === 'city') {
          value = value?.label;
        } else if (key === 'usecase') {
          value = value;
        } else if (key === 'mobile_number') {
          if (contactNumberMessage) return true;
          value = value;
        } else {
          key = null;
          value = null;
        }

        // if (userDetails) {
        //   let currentUserData = Object.entries(userDetails);

        //   currentUserData.forEach((property) => {
        //     let userKey = property[0];
        //     let userValue = property[1];

        //     if (userKey === key && userValue !== value) {
        //       console.log("changeUserDetails currentUserData: ", currentUserData)
        if (key) {
          if (key === 'usecase') {
            if (value) {
              value.forEach((x) => formData.append('usecase', x?.value));
            }
          } else if (key === 'country' || key === 'state' || key === 'city') {
            formData.append(key, value || '');
          } else {
            if (value) formData.append(key, value);
          }
        }
        //     }
        //   });
        // }
      });
      apiUpdateUserDetails(formData).then((response) => {
        setUserData(response);
      });
    }
  }

  const handleChange = ({ name, value }) => {
    formData[name] = value.trim();
    setData(formData);
  };

  const handledesignationChange = ({ name, value }) => {
    formData[name] = value.trim();
    setData(formData);
  };

  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleUpdate = () => {
    setIsSubmitting(true);

    var form_data = new FormData();
    for (var key in formData) {
      form_data.append(key, formData[key]);
    }
    apiUpdateUserDetails(form_data)
      .then((response) => {
        setUserDetails(response);

        // Close any editing instance opened for name and/or designation
        setEditingName(false);
        setEditingDesignation(false);
      })
      .catch((error) => {
        errorToast(error?.message || 'Something went wrong. Please try again later!');
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  const handleClose = () => {
    setShow(false);
  };

  const handlePpChange = async (file) => {
    if (checkFileSize(file.size, 5)) {
      setSaving(true);
      let formData = new FormData();
      formData.append('profile_image', file);
      try {
        const response = await apiUpdateUserDetails(formData);

        if (response && response.profile_image) {
          await loadImage({ src: response.profile_image });

          setProfileImg(response.profile_image);
          userCtx.changeProfilePic?.(response.profile_image);
        }
      } catch (e) {
        //captureException(e);
        errorToast('Something went wrong while updating profile picture');
      }

      setSaving(false);
    } else {
      errorToast('You attachment must not exceed 5 Mb.');
    }
  };

  const togglePassword1 = () => {
    setPasswordShown1(!passwordShown1);
  };

  const togglePassword2 = () => {
    setPasswordShown2(!passwordShown2);
  };

  const togglePassword3 = () => {
    setPasswordShown3(!passwordShown3);
  };

  const initialValues = {
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  };

  const valueMatchCheck = 'New and confirm password must match';
  const currentNewMatch = "Current and new password can't be same";
  const validationSchema = Yup.object().shape({
    currentPassword: Yup.string().required('Current password is required'),
    newPassword: Yup.string()
      .required('New password is required')
      .min(MIN_PASSWORD_LENGTH, VALID_PASSWORD_MESSAGE)
      .test(
        'old-new',
        currentNewMatch,
        (value, newPassword) => !pwdMatchCheck(value, newPassword.parent.currentPassword)
      ),
    confirmPassword: Yup.string()
      .required('Confirm password is required')
      .min(MIN_PASSWORD_LENGTH, VALID_PASSWORD_MESSAGE)
      .test('confirm-new', valueMatchCheck, (value, confirmPassword) =>
        pwdMatchCheck(value, confirmPassword.parent.newPassword)
      ),
  });

  const onSubmit = (values, { setSubmitting }) => {
    const payload = {
      old_password: values?.currentPassword,
      new_password: values?.newPassword,
    };
    setSavePassword(true);
    apiChangePassword(objectToFormData(payload))
      .then((response) => {
        response && handleClose();
      })
      .finally(() => {
        setSubmitting(false);
        setSavePassword(false);
      });
  };

  const formSettings = {
    initialValues,
    validationSchema,
    onSubmit,
  };

  const handeFirstNameChange = ({ name, value }) => {
    if (!value.trim()) {
      setFirstNameError('Please provide first name');
    } else if (value.length > MAX_FIRST_NAME_LENGTH) {
      setFirstNameError(
        `First name should be less or equal to ${MAX_FIRST_NAME_LENGTH} characters`
      );
    } else {
      setFirstNameError('');
    }

    handleChange({ name, value });
  };

  const handleLastNameChange = ({ name, value }) => {
    if (!value.trim()) {
      setLastNameError('Please provide last name');
    } else if (value.length > MAX_LAST_NAME_LENGTH) {
      setLastNameError(`Last name should be less or equal to ${MAX_LAST_NAME_LENGTH} characters`);
    } else {
      setLastNameError('');
    }

    handleChange({ name, value });
  };

  const nameError = firstNameError || lastNameError;

  if (loading) return <Loader loading backdrop />;

  return (
    <>
      <div className="d-flex my-details-grid">
        <div>
          <div className="left-section details-page">
            <AvatarRow
              src={profileImg}
              label="Profile Picture"
              onFileSelect={handlePpChange}
              loading={saving}
            />

            <ViewEditItem
              label={nameError || 'Name'}
              onUpdate={() => {
                if (!firstNameError && !lastNameError) {
                  handleUpdate();
                }
              }}
              value={
                userDetails
                  ? `${removeUndefinedText(userDetails.first_name)} ${removeUndefinedText(
                    userDetails.last_name
                  )}`
                  : ''
              }
              error={nameError}
              editing={editingName}
              setEditing={(e) => {
                setEditingName(e);
                setFirstNameError('');
                setLastNameError('');
              }}
              isSubmitting={isSubmitting}>
              <div className="w-100">
                <Input
                  className={cx('w-100 my-details-input mb-2', firstNameError && 'input-error')}
                  name="first_name"
                  onChange={handeFirstNameChange}
                  required
                  defaultData={userDetails}
                  placeholder="First Name"
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' && !firstNameError && !lastNameError) {
                      handleUpdate();
                    }
                  }}
                />
                <Input
                  className={cx('w-100 my-details-input', lastNameError && 'input-error')}
                  name="last_name"
                  onChange={handleLastNameChange}
                  required
                  defaultData={userDetails}
                  placeholder="Last Name"
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' && !firstNameError && !lastNameError) {
                      handleUpdate();
                    }
                  }}
                />
              </div>
            </ViewEditItem>
            <div className="input-border">
              <div className="d-flex align-items-center justify-content-between">
                <div>
                  <label className="detail-label">Email</label>
                  <span className="detail-info">{userDetails?.email}</span>
                </div>
                <div className="contact-support">
                  <OverlayTrigger
                    placement="bottom"
                    delay={150}
                    overlay={<Tooltip id="button-tooltip-2">To change your email</Tooltip>}>
                    {({ ref, ...triggerHandler }) => (
                      <div
                        ref={ref}
                        {...triggerHandler}
                        className="d-flex align-items-center gap-2 contact-support-text">
                        <InfoIcon style={{ color: '#292D32' }} />
                        Contact Support
                      </div>
                    )}
                  </OverlayTrigger>
                </div>
              </div>
            </div>
            <div className="input-border">
              <span className="detail-links" onClick={handleShow}>
                Edit password
              </span>
              <Modal
                show={show}
                onHide={handleClose}
                animation={false}
                className="edit-pw-modal lf-modal-default modal-dialog-centered">
                <Button onClick={handleClose} className="modalCloseButton lf-modal-close-button">
                  <CloseIconSmall />
                </Button>

                <Modal.Body className="screen-form-wrapper">
                  <div className="text-center mb-4">
                    <h2 className="pg-title mb-0">Edit password</h2>
                  </div>

                  <Formik {...formSettings}>
                    {({
                      values,
                      errors,
                      touched,
                      isPasswordSubmitting,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                      setTouched,
                    }) => (
                      <Form
                        className="settings-modal"
                        onKeyDown={(e) => {
                          const code = e?.keyCode || e?.which;
                          if (code === 13) {
                            e.preventDefault();
                            handleSubmit();
                          }
                        }}>
                        <Form.Group className="form-outline" controlId="formBasicEmail">
                          {errors.currentPassword && touched.currentPassword ? (
                            <Form.Label className="text-danger pwd-overflow">
                              <ExclamationIcon />
                              <span>{errors.currentPassword}</span>
                            </Form.Label>
                          ) : (
                            <Form.Label className="title-color float-left">
                              <span>Current Password</span>
                            </Form.Label>
                          )}
                          <Form.Control
                            className={cx(
                              errors.currentPassword && touched.currentPassword && 'input-error'
                            )}
                            type={passwordShown1 ? 'text' : 'password'}
                            placeholder="Type here your current password"
                            name="currentPassword"
                            onChange={handleChange}
                            onFocus={() => setTouched({ ...touched, currentPassword: false })}
                            onBlur={handleBlur}
                            value={values.currentPassword}
                            maxLength={MAX_PASSWORD_LENGTH}
                          />
                          {passwordShown1 ? (
                            <RiEyeLine className="eye-icon" onClick={togglePassword1} />
                          ) : (
                            <RiEyeOffLine className="eye-icon" onClick={togglePassword1} />
                          )}
                        </Form.Group>
                        <Form.Group className="link-text align-right mid">
                          <Link
                            to={FORGET_ROUTE_SETTINGS}
                            className="lf-link float-right text-decoration-none">
                            I forgot my password
                          </Link>
                        </Form.Group>
                        <Form.Group className="form-outline">
                          {errors.newPassword && touched.newPassword ? (
                            <Form.Label className="text-danger pwd-overflow">
                              <ExclamationIcon />
                              <span>{errors.newPassword}</span>
                            </Form.Label>
                          ) : (
                            <Form.Label className="title-color float-left">
                              <span>New Password</span>
                            </Form.Label>
                          )}
                          <Form.Control
                            className={cx(
                              errors.newPassword && touched.newPassword && 'input-error'
                            )}
                            placeholder="Type here your new password"
                            type={passwordShown2 ? 'text' : 'password'}
                            onChange={handleChange}
                            name="newPassword"
                            onFocus={() => setTouched({ ...touched, newPassword: false })}
                            onBlur={handleBlur}
                            value={values.newPassword}
                            maxLength={MAX_PASSWORD_LENGTH}
                          />
                          {passwordShown2 ? (
                            <RiEyeLine className="eye-icon" onClick={togglePassword2} />
                          ) : (
                            <RiEyeOffLine className="eye-icon" onClick={togglePassword2} />
                          )}
                        </Form.Group>
                        <Form.Group className="form-outline">
                          {errors.confirmPassword && touched.confirmPassword ? (
                            <Form.Label className="text-danger pwd-overflow">
                              <ExclamationIcon />
                              <span>{errors.confirmPassword}</span>
                            </Form.Label>
                          ) : (
                            <Form.Label className="title-color float-left">
                              <span>Confirm New Password</span>
                            </Form.Label>
                          )}
                          <Form.Control
                            className={cx(
                              errors.confirmPassword && touched.confirmPassword && 'input-error'
                            )}
                            type={passwordShown3 ? 'text' : 'password'}
                            placeholder="Repeat your new password"
                            onChange={handleChange}
                            name="confirmPassword"
                            onFocus={() => setTouched({ ...touched, confirmPassword: false })}
                            onBlur={handleBlur}
                            value={values.confirmPassword}
                            maxLength={MAX_PASSWORD_LENGTH}
                          />
                          {passwordShown3 ? (
                            <RiEyeLine className="eye-icon" onClick={togglePassword3} />
                          ) : (
                            <RiEyeOffLine className="eye-icon" onClick={togglePassword3} />
                          )}
                        </Form.Group>
                        <Form.Group className="form-btn">
                          <BigButton
                            type="button"
                            disabled={isPasswordSubmitting}
                            className="bigButton lf-btn-1 w-100"
                            buttonTitle="Save"
                            onClick={handleSubmit}
                            isLoading={savePassword}
                          />
                        </Form.Group>
                      </Form>
                    )}
                  </Formik>
                </Modal.Body>
              </Modal>
            </div>
            <ViewEditItem
              label="Designation"
              onUpdate={handleUpdate}
              value={userDetails ? userDetails.designation : ''}
              editing={editingDesignation}
              setEditing={setEditingDesignation}
              isSubmitting={isSubmitting}>
              <Input
                label={false}
                className="w-100 my-details-input"
                name="designation"
                placeholder="Designation"
                onChange={handledesignationChange}
                maxLength={MAX_DESIGNATION_LENGTH}
                required
                defaultData={userDetails}
                onKeyDown={(e) => {
                  if (e.key !== 'Enter') return;
                  handleUpdate();
                }}
              />
            </ViewEditItem>
          </div>
        </div>
        <OrgSection userDetails={userDetails} getUserDetails={getUserDetails} />
      </div>

      <div className="d-flex my-details-grid">
        <div>
          <UserInfo
            // hideBanner,
            countryMessage={countryMessage}
            setCountryMessage={setCountryMessage}
            stateMessage={stateMessage}
            setStateMessage={setStateMessage}
            cityMessage={cityMessage}
            setCityMessage={setCityMessage}
            contactNumberMessage={contactNumberMessage}
            setContactNumberMessage={setContactNumberMessage}
            professionMessage={professionMessage}
            setProfessionMessage={setProfessionMessage}
            industryMessage={industryMessage}
            setIndustryMessage={setIndustryMessage}
            platformMessage={platformMessage}
            setPlatformMessage={setPlatformMessage}
            onUserPreferenceDataChange={changeUserDetails}
            inSettings={true}
          />
        </div>
      </div>
      {/* {showSavePassword ? <SavedDetails /> : ""} */}
    </>
  );
}
